import { Component } from '@angular/core';
import { TasksService } from '../tasks.service';
import { Observable } from 'rxjs';
import { Task } from '../task.type';
import { mapTo, startWith } from 'rxjs/operators';

@Component({
  selector: 'ls-tasks-overview',
  templateUrl: './taks-overview.component.html',
  styleUrls: ['./task-overview.component.scss']
})
export class TasksOverviewComponent {
  tasks$: Observable<Task[]>;
  loading$: Observable<boolean>;

  constructor(private tasksService: TasksService) {
    this.tasks$ = tasksService.getAllTasks();
    this.loading$ = this.tasks$.pipe(
      mapTo(false),
      startWith(true)
    );
  }

  getStatus(task: Task) {
    switch (task.status) {
      case 'success':
        return 'Successful';
      case 'failed':
        return 'Failed';
      case 'warning':
        return 'Imported with errors';
      default:
        return 'Running';
    }
  }

  getResult(task: Task) {
    this.tasksService.getResult(task.id);
  }
}
